import React from 'react';
import { ReactComponent as ChevronRight } from '../assets/icons/chevron-right.svg';
import IconCircle from './IconCircle';

/**
 * "Enjoy AutoFill", "Dark Web Monitoring"... icono en circulo + titulo + subtitulo
 * + chevron. onClick opcional; si no hay onClick se renderiza como bloque informativo.
 */
function FeatureBanner({ icon, tone = 'accent', title, subtitle, onClick, className = '' }) {
  const Wrapper = onClick ? 'button' : 'div';
  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      className={`sgc-feature-banner ${onClick ? 'sgc-feature-banner--clickable' : ''} ${className}`}
      onClick={onClick}
    >
      <IconCircle icon={icon} tone={tone} size={40} />
      <div className="sgc-feature-banner__text">
        <p className="sgc-feature-banner__title">{title}</p>
        {subtitle && <p className="sgc-feature-banner__subtitle">{subtitle}</p>}
      </div>
      {onClick && <ChevronRight className="sgc-feature-banner__chevron" width={20} height={20} aria-hidden="true" />}
    </Wrapper>
  );
}

export default FeatureBanner;
